import { render, staticRenderFns } from "./MechanicAssets.vue?vue&type=template&id=22a8204a&scoped=true&"
import script from "./MechanicAssets.vue?vue&type=script&lang=js&"
export * from "./MechanicAssets.vue?vue&type=script&lang=js&"
import style0 from "./MechanicAssets.vue?vue&type=style&index=0&id=22a8204a&scoped=true&lang=css&"
import style1 from "./MechanicAssets.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8204a",
  null
  
)

export default component.exports